









































































































import {
  computed,
  defineComponent,
  nextTick,
  onUpdated,
  ref,
  useFetch,
  useMeta,
  useRoute,
} from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { useContent } from '~/composables/useContent'
import { useFaqList } from '~/composables/useFaq'
import { useBreakpoint } from '~/composables/ui/useBreakpoint'
import { useHeaderHeight } from '~/composables/ui/useHeaderHeight'

export default defineComponent({
  name: 'PagesFaq',

  setup() {
    const {
      mainFaq,
      mainFaqLoading,
      subFaqs,
      subFaqsLoading,
      getMainFaq,
      getSubFaqs,
    } = useFaqList()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const {
      breadcrumbsSchemaScript,
      setBreadcrumbsSchemaScript,
    } = useBreadcrumbsSchemaScript()
    const { loading: contentLoading, article, ensureContent } = useContent()
    const { isTabletAndDesktop } = useBreakpoint()
    const { scrolledHeight: scrolledHeaderHeight } = useHeaderHeight(
      isTabletAndDesktop
    )
    const route = useRoute()

    const shouldScrollToHash = ref(!!route.value.hash)

    const title = computed(
      () => (article.value?.title || mainFaq.value?.name) ?? ''
    )
    const heading = computed(() => article.value?.heading)

    useFetch(async () => {
      await Promise.all([ensureContent(), getMainFaq()])
      const key = mainFaq.value?.children?.[0]?.key
      if (!key) return

      setBreadcrumbs([
        {
          to: { name: 'all', params: { pathMatch: 'klantenservice' } },
          label: title.value,
        },
      ])
      setBreadcrumbsSchemaScript(breadcrumbs.value!)
      await getSubFaqs()
    })

    onUpdated(() => {
      nextTick(() => {
        if (!shouldScrollToHash.value || !subFaqs.value.length) return
        const el = window.document.querySelector(
          `#a-${route.value.hash.replace('#', '')}`
        )
        if (el) {
          ;(el as typeof el & { click: () => void }).click()
          shouldScrollToHash.value = false
        }
      })
    })

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    return {
      isTabletAndDesktop,
      scrolledHeaderHeight,
      contentLoading,
      title,
      heading,
      mainFaq,
      mainFaqLoading,
      subFaqs,
      subFaqsLoading,
    }
  },

  head: {},
})
